import * as THREE from 'three';

import { composer } from '@/threejs/core';
import { updateCameraAspect } from '@/threejs/core/camera';

// Create Renderer
export const renderer = new THREE.WebGLRenderer({
  antialias: true,
  alpha: true,
  logarithmicDepthBuffer: true,
});

// Initialize with default size, will be updated when container is provided
renderer.setSize(1600, 900);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

// Configure renderer settings
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;
renderer.outputEncoding = THREE.SRGBColorSpace;
renderer.outputColorSpace = THREE.SRGBColorSpace;
renderer.toneMapping = THREE.ACESFilmicToneMapping;

// Disable physically correct lighting globally - too bright for scene illumination
// We'll handle projector lighting with custom lumens-to-candela conversion
renderer.useLegacyLights = false;
renderer.physicallyCorrectLights = true;
renderer.toneMappingExposure = 1.0;

// Update renderer size
export function updateRendererSize(container) {
  if (!container) {
    console.error('Container is required for renderer update');
    return;
  }

  setTimeout(() => {
    const width = container.clientWidth;
    const height = container.clientHeight;

    if (width === 0 || height === 0) {
      console.warn('Container has zero dimensions in updateRendererSize', {
        width,
        height,
      });
      return;
    }
    updateCameraAspect(container);
    renderer.setSize(width, height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    composer.render();
  }, 0);
}

// Cleanup renderer
export function cleanupRenderer() {
  renderer.dispose();
}
